
import servise from '@/router/axios'

export const mockReq = (data) => {
  return servise({
    url: '/req/dsp/testBidding',
    method: 'post',
    data
  })
}